import { render, staticRenderFns } from "./TableHomeworkProgressStudents.vue?vue&type=template&id=59578be1&scoped=true"
import script from "./TableHomeworkProgressStudents.vue?vue&type=script&lang=js"
export * from "./TableHomeworkProgressStudents.vue?vue&type=script&lang=js"
import style0 from "./TableHomeworkProgressStudents.vue?vue&type=style&index=0&id=59578be1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59578be1",
  null
  
)

export default component.exports